<template>
  <div>
    <timeline-break
      v-for="(interval, index) in visibleBreaks"
      :key="index"
      :start="interval.start"
      :end="interval.end"
      :border-width="breakBorderWidth"
    />
  </div>
</template>

<script>
import TimelineBreak from "./TimelineBreak.vue";
import { SCALE_MODE, isScaleModeValid } from "@/constants.js";

// @group Timeline
// Timeline breaks area
export default {
  components: {
    TimelineBreak
  },
  props: {
    /** breaks timestampsa area */
    breaks: {
      type: Array,
      default: () => []
    },
    /** visible area begin (in seconds) */
    start: {
      type: Number,
      required: true
    },
    /** visible area end (in seconds) */
    end: {
      type: Number,
      required: true
    },
    /** how near timeline zoomed */
    scaleMode: {
      type: String,
      default: SCALE_MODE.NORMAL,
      validator(mode) {
        return isScaleModeValid(mode);
      }
    }
  },
  computed: {
    // @vuese
    // Breaks interval scaled to visible area length
    percentBreaks() {
      return this.breaks.map(interval => ({
        start: this.convertToPercentsFromTime(interval.start),
        end: this.convertToPercentsFromTime(interval.end)
      }));
    },
    // @vuese
    // Scaled breaks interval that are visible on timeline
    visibleBreaks() {
      return this.percentBreaks.filter(interval =>
        [interval.start, interval.end].some(
          percent => percent >= 0 && percent <= 1
        )
      );
    },
    // @vuese
    // Dynamic break area border width
    breakBorderWidth() {
      switch (this.scaleMode) {
        case SCALE_MODE.CLOSE:
          return 3;
        case SCALE_MODE.NEAR:
          return 2;
        case SCALE_MODE.NORMAL:
          return 2;
        case SCALE_MODE.AWAY:
          return 1;
        case SCALE_MODE.FARAWAY:
          return 1;
        default:
          return 0;
      }
    },
    // @vuese
    // Visible timeline length
    length() {
      return this.end - this.start;
    }
  },
  methods: {
    // @vuese
    // Return time scaled to visible timeline length
    // @arg time - unix timestamp
    convertToPercentsFromTime(time) {
      return (time - this.start) / this.length;
    }
  }
};
</script>
